import Fuse from "fuse.js";
import { useEffect, useRef, useState } from "react";
import { getFuseOptions } from "../../../utils/searchUtils/fuseUtils";
import SearchBar from "../SearchBar/SearchBar";
import classes from "./AutoCompleteSearch.module.css";
import { GreenTag } from "../../Common";
import api from "../../../api";
import { useDispatch, useSelector } from "react-redux";
import { setElasticSearchEnabled } from "../../../actions/generalActions";

function AutoCompleteSearch({
  enteredInput,
  searchItems,
  keys,
  onSearch,
  formatResult,
  additionalResults,
  onFocus,
  placeholder,
  onEnter,
  onCloseResults,
  searchBarClassName,
  onResultsOpen,
  isResultsAlwaysOpen,
  userLocation,
}) {
  const [searchResults, setSearchResults] = useState([]);
  const [fuse, setFuse] = useState(null);

  const dispatch = useDispatch();

  const elasticEnabled = useSelector((state) => state.general.elasticSearchEnabled);
  const elasticAllowed = useSelector((state) => state.general.elasticSearchAllowed);

  useEffect(() => {
    if (!isResultsAlwaysOpen) {
      try {
        window.addEventListener("click", function (e) {
          const clickBox = document.getElementById("clickbox");
          if (clickBox && clickBox.contains(e.target)) {
          } else {
            closeResultsHandler();
          }
        });
      } catch (ex) { }
    }
  }, []);

  useEffect(() => {
    const isOpen =
      (searchResults != null && searchResults.length > 0) ||
      (additionalResults != null && additionalResults.length > 0);

    onResultsOpen(isOpen);
  }, [searchResults, additionalResults]);

  useEffect(() => {
    if (searchItems) {
      initSearch();
    }
  }, [searchItems]);

  const initSearch = () => {
    const options = getFuseOptions(keys);
    setFuse(new Fuse(searchItems, options));
  };

  const searchElastic = async (searchTerm) => {
    if (!userLocation) {
      return;
    }
    // console.log("searching with ElasticSearch", searchTerm, "userLocation", userLocation);
    const { result, success, error } = await api.esSearch({
      searchTerm,
      pagesize: 4,
      location: userLocation,
    });
    if (!success) {
      console.error("ElasticSearch error", error);
      return;
    }
    console.log("AutoCompleteSearch with ElasticSearch returned", result);
    const stupidResults = result.hits.hits.map((result) => {
      //at some point, we should remove this mapping
      result.tags = result.tags?.map(t => typeof t == 'number' ? t : t.id);
      result.rest_categories = result.rest_categories?.map(t => typeof t == 'number' ? t : t.id);
      result.categories = result.categories?.map(t => typeof t == 'number' ? t : t.id);
      return { item: result };
    });
    onSearch(stupidResults, searchTerm, false);
    // onSearch(results, searchTerm, true);
    setSearchResults(stupidResults);
  }

  const search = async (searchTerm) => {
    if (elasticEnabled) {
      return await searchElastic(searchTerm);
    }

    if (fuse) {
      let fuseResults = fuse.search(searchTerm);
      onSearch(fuseResults, searchTerm);
      if (additionalResults) {
        fuseResults = fuseResults.filter(
          (result) =>
            !additionalResults.some(
              (additional) =>
                additional.id === result.item.id &&
                additional.entity_type === result.item.entity_type
            )
        );
      }
      const finalResults = fuseResults.slice(0, 4);
      setSearchResults(finalResults);
    }
  };

  const onClear = () => {
    closeResultsHandler();
    onEnter("");
  };

  const closeResultsHandler = () => {
    onCloseResults();
    setSearchResults([]);
  };

  return (
    <div className={ classes.mainContainer } id="clickbox">
      {elasticAllowed && <GreenTag
        key={'elastic'}
        tag={'elastic'}
        // icon={entity.icon}
        className={classes.entityTags}
        // style={{ margin: "0 0 0 0" }}
        tagName={"ElasticSearch"}
        isSelected={elasticEnabled}
        isDisabled={false}
        // isDisabled={!entity.count}
        onTagSelected={() => {
          const newValue = !elasticEnabled;
          setElasticSearchEnabled(dispatch, newValue);
        }}
      />}
      <div className={ classes.wrapper }>
        <SearchBar
          enteredInput={ enteredInput }
          onSearch={ search }
          onFocus={ onFocus }
          placeholder={ placeholder }
          onCloseResults={ closeResultsHandler }
          onEnter={ (searchTerm) => {
            onEnter(searchTerm);
            closeResultsHandler();
          } }
          onClear={ onClear }
          searchBarClassName={ searchBarClassName }
        />
        { (searchResults || additionalResults) && (
          <div className={ classes.resultsContainer } onClick={ closeResultsHandler }>
            { additionalResults.map((result) => formatResult(result)) }
            { searchResults.map((result) => formatResult(result.item)) }
          </div>
        ) }
      </div>
    </div>
  );
}

export default AutoCompleteSearch;
